// import React, { useState } from "react";
// import { API_URL } from "./config";
// import {
//   Container,
//   Typography,
//   Paper,
//   Tabs,
//   Tab,
//   Box,
//   TextField,
//   Button,
//   Alert,
//   CircularProgress,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { colors } from "./theme";
// import SessionToast from "./components/SessionToast";
// import { useLocation } from "react-router-dom";

// export default function SignInSignUp({ onAuth }) {
//   const [tab, setTab] = useState(0);
//   const [form, setForm] = useState({ email: "", password: "", name: "" });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const navigate = useNavigate();
//   const location = useLocation();
//   // Auth context
//   const { auth, isAuthenticated } = window.useAuth ? window.useAuth() : {};
//   const [toastOpen, setToastOpen] = useState(false);
//   const [toastMsg, setToastMsg] = useState("");

//   // Get redirect path from query param
//   const searchParams = new URLSearchParams(location.search);
//   const redirectPath = searchParams.get("redirect") || "/";

//   // After login, redirect only after auth context is ready
//   React.useEffect(() => {
//     if (
//       isAuthenticated &&
//       auth &&
//       auth.user &&
//       location.pathname === "/signin"
//     ) {
//       let finalRedirect = "/";
//       // RBAC: applicant cannot access /admin, admin cannot access /candidate
//       const isApplicant = !!auth.user.is_applicant;
//       if (
//         redirectPath &&
//         redirectPath !== "/signin" &&
//         redirectPath !== "/login" &&
//         ((isApplicant && !redirectPath.startsWith("/admin")) ||
//           (!isApplicant && !redirectPath.startsWith("/candidate")))
//       ) {
//         finalRedirect = redirectPath;
//       } else if (isApplicant) {
//         finalRedirect = "/candidate";
//       } else {
//         finalRedirect = "/admin";
//       }
//       if (finalRedirect !== location.pathname) {
//         setToastMsg("Welcome back! Redirected to your last page.");
//         setToastOpen(true);
//         setTimeout(() => navigate(finalRedirect, { replace: true }), 1200);
//       }
//     }
//     // eslint-disable-next-line
//   }, [isAuthenticated, auth, location.pathname]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((f) => ({ ...f, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError("");
//     try {
//       let url, payload;
//       if (tab === 0) {
//         // Sign In
//         url = API_URL + "/auth/login";
//         payload = { username: form.email, password: form.password };
//       } else {
//         // Sign Up
//         url = API_URL + "/signup/";
//         payload = {
//           email: form.email,
//           password: form.password,
//           full_name: form.name,
//         };
//       }
//       let fetchOptions;
//       if (tab === 0) {
//         // Login: use form-urlencoded
//         fetchOptions = {
//           method: "POST",
//           headers: { "Content-Type": "application/x-www-form-urlencoded" },
//           body: new URLSearchParams(payload).toString(),
//           credentials: "include",
//         };
//       } else {
//         // Sign Up
//         fetchOptions = {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         };
//       }
//       console.log(API_URL)
//       const res = await fetch(url, fetchOptions);
      
//       let data;
//       try {
//         data = await res.json();
//       } catch (e) {
//         throw new Error("Server error: Could not parse response.");
//       }
//       if (tab === 1) {
//         setLoading(false);
//         if (!res.ok) {
//           let errorMsg = "Signup failed";
//           console.log(data["error"]);
//           let msg = data["error"];
//           if (data) {
//             errorMsg = `Error: ${msg.message}`;
//           } else {
//             errorMsg = `Error ${msg.code}`;
//           }
//           setError(errorMsg);
//           return;
//         }
//         setForm({ email: "", password: "", name: "" });
//         // setError("");
//         setSuccess(
//           "A verification email has been sent. Please check your inbox and verify your email before logging in."
//         );
//         return;
//       }
//       if (tab === 0) {
//         if (!res.ok) {
//           throw new Error((data && data.detail) || "Invalid username or password. Please try again.");
//         }
//         onAuth(data); // Navigation now handled by effect below
//       } else {
//         if (res.ok && data && data.email) {
//           // Registration success: show success, optionally auto-login or redirect to login
//           setError("");
//           // Optionally, auto-login or show a message here
//           navigate("/signin", { replace: true });
//         } else {
//           let errorMsg =
//             (data && data.detail) ||
//             (data && data.error && data.error.message) ||
//             "Failed to create account";
//           if (data && data.error && data.error.details) {
//             errorMsg = data.error.details.map((e) => e.msg).join(", ");
//           }
//           throw new Error(errorMsg);
//         }
//       }
//     } catch (err) {
//       setError(err.message || "Failed to authenticate");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//   <Box
//     sx={{
//       minHeight: "100vh",
//       width: "100%",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       py: 6,
//       background: "radial-gradient(circle at top left, #E0EAFF 0, #F9FAFB 45%, #FFFFFF 100%)",
//       // background: "#F9FAFB",
//     }}
//   >
//     <Container maxWidth="xs">
//       <Paper
//         sx={{
//           p: 4,
//           borderRadius: 4,
//           boxShadow: "0 18px 45px rgba(15, 23, 42, 0.12)",
//           border: `1px solid ${colors.border}`,
//           backgroundColor: colors.cardBg,
//         }}
//       >
//         {success && (
//           <Alert severity="success" sx={{ mb: 2 }}>
//             {success}
//           </Alert>
//         )}

//         <Tabs
//           value={tab}
//           onChange={(_, v) => setTab(v)}
//           centered
//           sx={{
//             mb: 3,
//             "& .MuiTab-root": {
//               fontSize: 14,
//               fontWeight: 500,
//               color: colors.gray,
//               minWidth: 0,
//               px: 3,
//             },
//             "& .MuiTab-root.Mui-selected": {
//               color: colors.primary,
//             },
//             "& .MuiTabs-indicator": {
//               backgroundColor: colors.primary,
//               height: 2,
//               borderRadius: 1,
//             },
//           }}
//         >
//           <Tab label="Sign In" />
//           <Tab label="Sign Up" />
//         </Tabs>

//         <form onSubmit={handleSubmit}>
//           {tab === 1 && (
//             <TextField
//               label="Name"
//               name="name"
//               fullWidth
//               margin="normal"
//               value={form.name}
//               onChange={handleChange}
//               required
//             />
//           )}

//           <TextField
//             label="Email"
//             name="email"
//             type="email"
//             fullWidth
//             margin="normal"
//             value={form.email}
//             onChange={handleChange}
//             required
//           />

//           <TextField
//             label="Password"
//             name="password"
//             type="password"
//             fullWidth
//             margin="normal"
//             value={form.password}
//             onChange={handleChange}
//             required
//           />

//           {tab === 0 && (
//             <Box sx={{ mt: 1, mb: 1, textAlign: "right" }}>
//               <Button
//                 size="small"
//                 onClick={() => navigate("/forgot-password")}
//                 sx={{
//                   textTransform: "none",
//                   fontWeight: 400,
//                   fontSize: 13,
//                   color: colors.accent,
//                 }}
//               >
//                 Forgot password?
//               </Button>
//             </Box>
//           )}

//           {error && (
//             <Alert severity="error" sx={{ mt: 2 }}>
//               {error}
//             </Alert>
//           )}

//           <Button
//             type="submit"
//             variant="contained"
//             color="primary"
//             fullWidth
//             sx={{
//               mt: 3,
//               py: 1.4,
//               borderRadius: 999,
//               fontWeight: 600,
//               fontSize: 15,
//               boxShadow: "0 12px 25px rgba(37, 99, 235, 0.35)",
//               "&:hover": {
//                 boxShadow: "0 16px 35px rgba(37, 99, 235, 0.45)",
//               },
//             }}
//             disabled={loading}
//           >
//             {loading ? (
//               <CircularProgress size={24} color="inherit" />
//             ) : tab === 0 ? (
//               "Sign In"
//             ) : (
//               "Create Account"
//             )}
//           </Button>
//         </form>
//       </Paper>

//       <SessionToast
//         open={toastOpen}
//         onClose={() => setToastOpen(false)}
//         message={toastMsg}
//         severity="success"
//       />
//     </Container>
//   </Box>
// );
// }


import React, { useState } from "react";
import { API_URL } from "./config";
import {
  Container,
  Typography,
  Paper,
  Tabs,
  Tab,
  Box,
  TextField,
  Button,
  Alert,
  CircularProgress,
  Grid,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import SessionToast from "./components/SessionToast";

function SectionEyebrow({ children, color }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.25,
        color,
        fontFamily: '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: "10.5px",
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        fontWeight: 500,
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 2,
          borderRadius: 2,
          bgcolor: "currentColor",
          flexShrink: 0,
        }}
      />
      {children}
    </Box>
  );
}

export default function SignInSignUp({ onAuth }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const navigate = useNavigate();
  const location = useLocation();

  const accent = dark ? "#fb923c" : "#f97316";
  const pageBg = dark ? "#07080f" : "#ffffff";
  const cardBg = dark ? "#0d1220" : "#ffffff";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";
  const borderStrong = dark ? "rgba(99, 179, 237, 0.22)" : "#d4d4e4";

  const [tab, setTab] = useState(0);
  const [form, setForm] = useState({ email: "", password: "", name: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { auth, isAuthenticated } = window.useAuth ? window.useAuth() : {};
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  const searchParams = new URLSearchParams(location.search);
  const redirectPath = searchParams.get("redirect") || "/";

  React.useEffect(() => {
    if (
      isAuthenticated &&
      auth &&
      auth.user &&
      location.pathname === "/signin"
    ) {
      let finalRedirect = "/";
      const isApplicant = !!auth.user.is_applicant;

      console.log("DEBUG: auth.user =", auth.user);
console.log("DEBUG: isApplicant =", isApplicant);
console.log("DEBUG: is_superuser =", auth.user.is_superuser);
console.log("DEBUG: redirectPath =", redirectPath);

      if (
        redirectPath &&
        redirectPath !== "/signin" &&
        redirectPath !== "/login" &&
        ((isApplicant && !redirectPath.startsWith("/admin")) ||
          (!isApplicant && !redirectPath.startsWith("/candidate")))
      ) {
        finalRedirect = redirectPath;
      } else if (isApplicant) {
        finalRedirect = "/candidate";
      } else {
        finalRedirect = "/admin";
      }

      if (finalRedirect !== location.pathname) {
        setToastMsg("Welcome back. Redirecting you now.");
        setToastOpen(true);
        setTimeout(() => navigate(finalRedirect, { replace: true }), 1200);
      }
    }
  }, [isAuthenticated, auth, location.pathname, redirectPath, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const fieldSx = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "14px",
      background: dark ? "rgba(8,12,24,0.7)" : "#ffffff",
      color: text,
      transition: "all .2s ease",
      "& fieldset": {
        borderColor: border,
      },
      "&:hover fieldset": {
        borderColor: borderStrong,
      },
      "&.Mui-focused": {
        boxShadow: `0 0 0 4px ${alpha(accent, 0.12)}`,
      },
      "&.Mui-focused fieldset": {
        borderColor: accent,
      },
    },
    "& .MuiInputLabel-root": {
      color: mid,
      fontWeight: 500,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: accent,
    },
    "& .MuiInputBase-input": {
      color: text,
    },
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      let url;
      let payload;
      let fetchOptions;

      if (tab === 0) {
        url = API_URL + "/auth/login";
        payload = { username: form.email, password: form.password };

        fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams(payload).toString(),
          credentials: "include",
        };
      } else {
        url = API_URL + "/signup/";
        payload = {
          email: form.email,
          password: form.password,
          full_name: form.name,
        };

        fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        };
      }

      const res = await fetch(url, fetchOptions);

      let data;
      try {
        data = await res.json();
      } catch {
        throw new Error("Server error: Could not parse response.");
      }

      if (tab === 1) {
        if (!res.ok) {
          let errorMsg =
            data?.detail ||
            data?.error?.message ||
            "Could not create your account.";
          if (data?.error?.details) {
            errorMsg = data.error.details.map((d) => d.msg).join(", ");
          }
          throw new Error(errorMsg);
        }

        setForm({ email: "", password: "", name: "" });
        setSuccess(
          "Account created. Please check your email and verify your account before signing in."
        );
        setTab(0);
        return;
      }

      if (!res.ok) {
        throw new Error(
          data?.detail || "Invalid username or password. Please try again."
        );
      }

      onAuth(data);
    } catch (err) {
      setError(err.message || "Failed to authenticate.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        pt: { xs: 11, md: 13 },
        pb: 8,
        position: "relative",
        overflow: "hidden",
        bgcolor: pageBg,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          background: dark
            ? `radial-gradient(circle at 15% 12%, ${alpha(accent, 0.12)} 0%, transparent 26%),
               radial-gradient(circle at 85% 20%, rgba(56,189,248,0.10) 0%, transparent 24%)`
            : `radial-gradient(circle at 15% 12%, ${alpha(accent, 0.08)} 0%, transparent 24%),
               radial-gradient(circle at 85% 18%, rgba(79,70,229,0.06) 0%, transparent 22%)`,
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={3} alignItems="stretch">
          <Grid item xs={12} md={5}>
            <Paper
              elevation={0}
              sx={{
                height: "100%",
                p: { xs: 3, md: 4 },
                borderRadius: "28px",
                border: `1px solid ${border}`,
                background: dark
                  ? `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(7,8,15,0.96) 45%, rgba(7,8,15,0.98) 100%)`
                  : `linear-gradient(135deg, ${alpha(accent, 0.12)} 0%, rgba(255,255,255,0.98) 42%, rgba(248,248,251,0.98) 100%)`,
                boxShadow: dark
                  ? "0 32px 80px rgba(0,0,0,0.45)"
                  : "0 32px 80px rgba(15,15,26,0.08)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <SectionEyebrow color={accent}>
                  AjiraHQ · Candidate Access
                </SectionEyebrow>

                <Typography
                  sx={{
                    mt: 2,
                    color: text,
                    fontWeight: 800,
                    fontSize: "clamp(34px, 5vw, 52px)",
                    lineHeight: 1.04,
                    letterSpacing: "-0.03em",
                  }}
                >
                  Sign in to continue your hiring journey.
                </Typography>

                <Typography
                  sx={{
                    mt: 2.5,
                    color: mid,
                    fontSize: "16px",
                    lineHeight: 1.85,
                    maxWidth: 500,
                  }}
                >
                  Access your candidate experience, continue an application, or
                  create an account to apply for new opportunities.
                </Typography>
              </Box>

              <Box
                sx={{
                  mt: 4,
                  p: 2.5,
                  borderRadius: "20px",
                  border: `1px solid ${border}`,
                  background: dark ? "rgba(8,12,24,0.48)" : "rgba(255,255,255,0.72)",
                }}
              >
                {[
                  "Structured, fast applications",
                  "Secure sign in and account creation",
                  "Candidate-friendly hiring flow",
                ].map((item) => (
                  <Box
                    key={item}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 1.25,
                      mb: 1.5,
                      "&:last-child": { mb: 0 },
                    }}
                  >
                    <Box
                      sx={{
                        mt: 0.65,
                        width: 18,
                        height: 18,
                        borderRadius: 999,
                        display: "grid",
                        placeItems: "center",
                        bgcolor: alpha(accent, 0.14),
                        color: accent,
                        fontSize: "11px",
                        fontWeight: 800,
                        flexShrink: 0,
                      }}
                    >
                      ✓
                    </Box>
                    <Typography
                      sx={{
                        color: mid,
                        fontSize: "14px",
                        lineHeight: 1.75,
                        fontWeight: 500,
                      }}
                    >
                      {item}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={7}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 3, md: 4 },
                borderRadius: "28px",
                border: `1px solid ${border}`,
                background: cardBg,
                boxShadow: dark
                  ? "0 20px 50px rgba(0,0,0,0.28)"
                  : "0 20px 50px rgba(15,15,26,0.05)",
              }}
            >
              {success && (
                <Alert
                  severity="success"
                  sx={{
                    mb: 2.5,
                    borderRadius: "14px",
                  }}
                >
                  {success}
                </Alert>
              )}

              <Tabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                sx={{
                  mb: 3,
                  minHeight: 52,
                  "& .MuiTabs-flexContainer": {
                    gap: 1,
                  },
                  "& .MuiTab-root": {
                    minHeight: 52,
                    borderRadius: "12px",
                    textTransform: "none",
                    fontWeight: 700,
                    fontSize: 14,
                    color: mid,
                    alignItems: "flex-start",
                    px: 2,
                    zIndex: 1,
                  },
                  "& .MuiTab-root.Mui-selected": {
                    color: accent,
                  },
                  "& .MuiTabs-indicator": {
                    height: "100%",
                    borderRadius: "12px",
                    background: alpha(accent, dark ? 0.14 : 0.08),
                    border: `1px solid ${alpha(accent, 0.2)}`,
                  },
                }}
              >
                <Tab label="Sign In" />
                <Tab label="Sign Up" />
              </Tabs>

              <Typography
                sx={{
                  color: text,
                  fontWeight: 800,
                  fontSize: "clamp(26px, 3vw, 36px)",
                  lineHeight: 1.08,
                  letterSpacing: "-0.03em",
                }}
              >
                {tab === 0 ? "Welcome back" : "Create your account"}
              </Typography>

              <Typography
                sx={{
                  mt: 1.25,
                  mb: 3,
                  color: mid,
                  fontSize: "15px",
                  lineHeight: 1.8,
                }}
              >
                {tab === 0
                  ? "Sign in to continue your application or return to your previous page."
                  : "Create an account to apply for opportunities and manage your application journey."}
              </Typography>

              <form onSubmit={handleSubmit}>
                {tab === 1 && (
                  <TextField
                    label="Full Name"
                    name="name"
                    fullWidth
                    margin="normal"
                    value={form.name}
                    onChange={handleChange}
                    required
                    sx={fieldSx}
                  />
                )}

                <TextField
                  label="Email"
                  name="email"
                  type="email"
                  fullWidth
                  margin="normal"
                  value={form.email}
                  onChange={handleChange}
                  required
                  sx={fieldSx}
                />

                <TextField
                  label="Password"
                  name="password"
                  type="password"
                  fullWidth
                  margin="normal"
                  value={form.password}
                  onChange={handleChange}
                  required
                  sx={fieldSx}
                />

                {tab === 0 && (
                  <Box sx={{ mt: 1, mb: 1, textAlign: "right" }}>
                    <Button
                      size="small"
                      onClick={() => navigate("/forgot-password")}
                      sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: 13,
                        color: accent,
                        "&:hover": {
                          background: "transparent",
                          color: accent,
                          opacity: 0.9,
                        },
                      }}
                    >
                      Forgot password?
                    </Button>
                  </Box>
                )}

                {error && (
                  <Alert
                    severity="error"
                    sx={{
                      mt: 2,
                      borderRadius: "14px",
                    }}
                  >
                    {error}
                  </Alert>
                )}

                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 3,
                    py: 1.45,
                    borderRadius: "14px",
                    fontWeight: 800,
                    fontSize: 15,
                    background: accent,
                    color: "#fff",
                    boxShadow: `0 18px 44px ${alpha(accent, 0.24)}`,
                    "&:hover": {
                      background: accent,
                      filter: "brightness(1.08)",
                    },
                  }}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : tab === 0 ? (
                    "Sign In"
                  ) : (
                    "Create Account"
                  )}
                </Button>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Container>

      <SessionToast
        open={toastOpen}
        onClose={() => setToastOpen(false)}
        message={toastMsg}
        severity="success"
      />
    </Box>
  );
}